export const methodPayment = [
  {
    image:
      "https://www.paypalobjects.com/digitalassets/c/website/logo/full-text/pp_fc_hl.svg",
    description: "PayPal",
  },
  {
    image:
      "https://pay.google.com/about/static_kcs/images/logos/google-pay-logo.svg",
    description: "Google Pay",
  },
  {
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Apple_Pay_logo.svg/150px-Apple_Pay_logo.svg.png",
    description: "Apple Pay",
  },
  {
    image: "/static/base_images/credit-card-svgrepo-com.svg",
    description: "Credit Card",
    height: "70",
  },
];

export const languagePayment = [
  {
    text: "Il costo del servizio è di ",
    euro: "2,50 euro",
    durata: "La durata dell'audio è di circa 15 minuti",
    payChoice: "Scegli un metodo di pagamento.",
    index: "Indice",
    id: 1,
    payCash: "Il pagamento in contanti deve essere effettuato nel negozio",
    payOnline: "Il pagamento on line deve essere effettuato sul tuo smartphone",
    cash: "Contanti",
    shop: "nel negozio",
    paywith: "Paga in",
    password: "Password",
    listen: "Ascolta",
    email: "Email",
    information:
      "Per ottenere il codice, dirigersi al negozio Juliet di fronte alla coda d'ingresso in Via Cappello 15 oppure dentro al cortile in Via Cappello 23",
  },
  {
    text: "The cost of the service is ",
    euro: "2,50 euro",
    durata: "The duration of the audio is approximately 15 minutes",
    id: 2,
    index: "Table of contents",
    payChoice: "Choose a payment method",
    payCash: "Payment cash must be made in the shop",
    payOnline: "Payment on line must be made on your smartphone",
    cash: "Cash",
    shop: "in the shop",
    paywith: "Pay with",
    password: "Password",
    listen: "Listen",
    email: "Email",
    information:
      "To obtain the code, go to the Juliet shop in front of the entrance queue in Via Cappello 15 or inside the courtyard in Via Cappello 23",
  },
  {
    text: "El coste del servicio es de ",
    euro: "2,50 euro",
    durata: "La duración del audio es de aproximadamente 15 minutos.",
    id: 7,
    index: "Índice",
    payChoice: "Elija un método de pago",
    payCash: "El pago en efectivo debe realizarse dentro de la tienda",
    payOnline: "El pago en línea debe hacerse en su teléfono inteligente",
    cash: "dinero",
    shop: "en la tienda",
    paywith: "Pagar con",
    password: "Clave",
    listen: "Escuchar",
    email: "Email",
    information:
      "Para obtener el código, diríjase a la tienda Juliet frente a la cola de entrada en Via Cappello 15 o dentro del patio en Via Cappello 23",
  },
  {
    text: "Le coût de ce service est de ",
    euro: "2,50 euro",
    durata: "La durée de l'audio est d'environ 15 minutes",
    id: 4,
    index: "Index",
    payChoice: "Choisissez une méthode de paiement",
    payCash:
      "Le paiement en espèces doit être effectué à l’intérieur de la boutique",
    payOnline: "Le paiement en ligne doit être effectué sur votre smartphone",
    cash: "En espèces",
    shop: "dans la boutique",
    paywith: "Payer avec",
    password: "Mot de passe",
    listen: "écoute",
    Email: "Email",
    information:
      "Pour obtenir le code, rendez-vous à la boutique Juliette devant la file d'attente d'entrée Via Cappello 15 ou à l'intérieur de la cour Via Cappello 23",
  },
  {
    text: "Deze service kost ",
    euro: "2,50 euro",
    durata: "Die Dauer des Audios beträgt etwa 15 Minuten",
    id: 6,
    index: "Index",
    payChoice: "Wählen Sie eine Bezahlungsart",
    payCash: "Die Zahlung muss bar im Geschäft erfolgen",
    payOnline: "Die Online-Zahlung muss auf Ihrem Smartphone erfolgen",
    cash: "Contant geld",
    shop: "in de winkel",
    paywith: "Betaal met",
    password: "Wachtwoord",
    listen: "Luistert",
    Email: "Email",
    information:
      "Um den Code zu erhalten, gehen Sie zum Juliet-Shop vor der Eingangswarteschlange in der Via Cappello 15 oder im Innenhof in der Via Cappello 23",
  },
  {
    text: "Dieser Service kostet ",
    euro: "2.5 euro",
    durata: "De duur van de audio is ongeveer 15 minuten",
    id: 8,
    index: "Inhaltsverzeichnis",
    payChoice: "Kies een betaal methode",
    payCash: "In de winkel dient contant te worden betaald",
    payOnline: "Online betalen doe je op je smartphone",
    cash: "Kasse",
    shop: "im Geschäft",
    paywith: "Bezahle mit",
    password: "Passwort",
    listen: "Hört zu",
    email: "Email",
    information:
      "Om de code te verkrijgen, gaat u naar de Juliet-winkel voor de ingangsrij in Via Cappello 15 of op de binnenplaats in Via Cappello 23",
  },
  {
    text: "サービスの費用は",
    euro: "2.5ユーロです",
    durata: "音声の長さは約15分です",
    id: 5,
    index: "目次",
    payChoice: "お支払い方法を選択してください。",
    payCash: "代金は店頭でお支払いください。",
    payOnline: "オンラインでの支払いはスマートフォンで行う必要があります。",
    cash: "現金",
    shop: "その店で",
    paywith: "で支払う",
    password: "パスワード",
    listen: "聞く",
    email: "Eメール",
    information:
      "コードを入手するには、ViaCappello15の入口キューの前またはViaCappello23の中庭にあるジュリエットショップに行きます。",
  },
  {
    text: "本次服務費用為",
    euro: "2.5歐元。",
    durata: "音頻的持續時間約為 15 分鐘",
    id: 3,
    index: "目錄",
    payChoice: "选择一种付款方式。",
    payCash: "必须在店内支付现金。",
    payOnline: "在线支付必须在您的智能手机上进行。",
    cash: "現金",
    shop: "在商店裡",
    paywith: "使用。。。支付",
    password: "密碼",
    listen: "聽",
    email: "電子郵件",
    information:
      "要獲取代碼，請前往 Via Cappello 15 入口隊列前的 Juliet 商店或 Via Cappello 23 庭院內",
  },
];
